import React, {Component} from 'react';
import locales_es from "../../locales/es";
import Form from "../form";
import APIService from "../../modules/apiService";
import Helpers from "../../modules/helpers";
import {
  DAYS_OF_THE_WEEK,
  DEFAULT_TIME_ZONE,
  FC_SLOT_MAX_TIME,
  FC_SLOT_MIN_TIME,
  HREF_PAGE_ADD_CLINIC,
  HREF_PAGE_MEDIC_EDIT_TIMETABLES,
  hrefDashboard, MODAL_STATE, MODAL_TYPE, PAYMENT_METHOD_AMOUNT_TYPE_PERCENT, PLAN_TAGS,
  USER_TYPE_MEDIC,
  USER_TYPE_SECRETARY
} from "../../models/constants";

import Loading from './../../components/loading';
import TimezoneService from "../../modules/timezoneService";
import ConfigService from "../../modules/configService";
import AuthService from "../../modules/authService";
import DateTimeService from "../../modules/DateTimeService";
import PricesTable from "../pricesTable";
import PriceModal from "../priceModal";
import NoAttentionPlaces from "../noAttentionPlaces";
import {SubscriptionPlanContext} from "../../context/SubscriptionPlanContext";
import {subscribeToPlanWithModal} from "../../modules/PlanService";
import withModalContext from '../../context/withModalContext';
import Spinner from "../spinner";

class MedicTimetableForm extends Component {
  static contextType = SubscriptionPlanContext;

  constructor(props) {
    super(props);
    const isEdit = Boolean(props.timetableId);
    const isClone = isEdit && new URLSearchParams(window.location.search).get('clone') === 'true';

    this.state = {
      loading: false,
      mode: isClone ? 'clone' : isEdit ? 'edit' : 'add',

      // Lookups
      clinics: null,
      clinicId: null,
      consultingRoomOptions: [{id: 0}],
      timezoneOptions: [{value: 0, label: locales_es.loading}],
      timezone: DEFAULT_TIME_ZONE,
      appointmentTypes: [],
      appointmentTypeId: null,
      currencies: [],
      amountTypes: [],
      enableBeforePayment: props.medic.enable_before_payment,
      editionDisabled: false,
      requiresPayment: false,

      // Timetable fields
      day: DAYS_OF_THE_WEEK[0].value,
      duration: isEdit ? 0 : 15,
      start: isEdit ? '' : FC_SLOT_MIN_TIME,
      end: isEdit ? '' : FC_SLOT_MAX_TIME,
      startDate: null,
      endDate: null,
      enabled: true,
      comment: '',
      footer_email_text: '',
      limitTimePostAppointment: 0,
      limitTimeCancelAppointment: 0,
      prices: [],
      price: null,
      isClone,
    };

    // Services
    this.api = new APIService();
    this.helpers = new Helpers();
    this.auth = new AuthService();
    this.timezoneService = new TimezoneService();
    this.configService = new ConfigService();
    this.dateTimeService = new DateTimeService();

    // Bindings
    this.handleChange = this.handleChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.toggleRequiresPayment = this.toggleRequiresPayment.bind(this);
    this.toggleEnable = this.toggleEnable.bind(this);
    this.send = this.send.bind(this);
    this.onSavePriceModal = this.onSavePriceModal.bind(this);
    this.onRemovePrice = this.onRemovePrice.bind(this);
    this.onEditPrice = this.onEditPrice.bind(this);
    this.goBack = this.goBack.bind(this);
    this.goToEditClinic = this.goToEditClinic.bind(this);
  }

  componentDidMount() {
    if (![USER_TYPE_MEDIC, USER_TYPE_SECRETARY].includes(this.props.userType)) {
      window.location.href = hrefDashboard;
      return;
    }
    this.loadCurrencies();
    this.loadAmountTypes();
    this.loadAppointmentTypes();
    this.loadTimezones();
    if (this.props.userType === USER_TYPE_MEDIC) this.loadMedicClinics();
    else this.loadSecretaryClinic();
    if (this.state.mode === 'edit' || this.state.mode === 'clone') this.getTimetable();
  }

  loadCurrencies() {
    this.api.getCurrencies()
      .then(res => this.setState({currencies: res.data}))
      .catch(err => this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err)));
  }

  loadAmountTypes() {
    this.api.getPaymentsAmountTypes()
      .then(res => this.setState({amountTypes: res.data}))
      .catch(err => this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err)));
  }

  loadAppointmentTypes() {
    this.api.getAppointmentsTypes()
      .then(res => this.setState({appointmentTypes: res.data, appointmentTypeId: res.data[0]?.id}))
      .catch(err => this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err)));
  }

  loadTimezones() {
    this.timezoneService.getRemoteParsedTimezones()
      .then(list => this.setState({
        timezoneOptions: list,
        timezone: list.find(t => t.value === this.state.timezone) || list[0]
      }))
      .catch(err => this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err)));
  }

  loadMedicClinics() {
    this.api.getMyClinics()
      .then(res => this.setState({clinics: res.data}, () => this.setState({
        clinicId: this.state.clinics[0]?.id,
        consulting_room_id: this.state.consultingRoomOptions[0].id,
        day: DAYS_OF_THE_WEEK[0].value
      })))
      .catch(err => this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err)));
  }

  loadSecretaryClinic() {
    this.configService.getLocalClinicData()
      .then(clinic => this.setState({clinicId: clinic.id}, () => this.api.getConsultingRooms({clinic_id: this.state.clinicId})
        .then(res => this.setState({
          consultingRoomOptions: res.data,
          consulting_room_id: res.data[0]?.id,
          day: DAYS_OF_THE_WEEK[0].value,
          clinics: [clinic]
        }))
        .catch(err => this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err)))))
      .catch(console.error);
  }

  getTimetable() {
    this.setState({loading: true});
    this.api.getTimetableById(this.props.timetableId)
      .then(res => {
        const t = res.data;
        this.setState({
          prices: t.prices || [],
          clinicId: t.clinic_id,
          consulting_room_id: t.consulting_room_id,
          day: t.day,
          duration: t.duration,
          comment: t.comment,
          enabled: t.enabled,
          requiresPayment: t.requires_payment,
          footer_email_text: t.footer_email_text,
          appointmentTypeId: t.type_id,
          start: t.start,
          end: t.end,
          startDate: t.start_date ? new Date(t.start_date) : null,
          endDate: t.end_date ? new Date(t.end_date) : null,
          timezone: this.state.timezoneOptions.find(z => z.value === t.time_zone) || this.state.timezone,
          limitTimePostAppointment: t.limit_time_post_appointment,
          limitTimeCancelAppointment: t.limit_time_cancel_appointment,
          loading: false
        }, () => {
          if (this.state.mode === 'edit') this.checkEditionDisable(t);
        });
      })
      .catch(err => this.setState({loading: false}, () => this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err))));
  }

  checkEditionDisable(t) {
    if (this.props.userType === USER_TYPE_MEDIC) {
      this.api.getMyClinics()
        .then(res => this.setState({editionDisabled: !res.data.some(c => Number(c.id) === Number(t.clinic_id))}))
        .catch(err => this.setState({editionDisabled: true}, () => this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err))));
    }
  }

  // Updated handleChange for Form compatibility
  handleChange(field) {
    return e => this.setState({[field]: e.target.value});
  }

  handleDateChange(state) {
    return v => this.setState({[state]: v});
  }

  handleSelectChange(state) {
    return v => this.setState({[state]: v});
  }

  async toggleRequiresPayment() {
    const {hasFeature} = this.context;
    const {requiresPayment} = this.state;

    if (!requiresPayment) { // if we are enabling requires payment, we need to check if the plan allows it
      if (!hasFeature('appointment-requires-payment')) {
        // this.props.showMainModal('Acción no permitida', 'Tu plan actual no permite activar el cobro de turnos.');
        subscribeToPlanWithModal(PLAN_TAGS.PRO, this.props.showMainModal);
        return;
      }
      if (this.props.userType === USER_TYPE_SECRETARY) {
        this.setState({requiresPayment: !requiresPayment});
      } else {
        this.api.getMercadoPagoInfo().then(() => {
          this.setState({
            requiresPayment: !requiresPayment
          });
        }).catch((err) => {
          this.openMercadoPagoLinkModal(this.props.modalContext.dispatch, err);
        })
      }
    } else {
      this.setState({requiresPayment: !requiresPayment});
    }

  }

  toggleEnable() {
    this.setState(s => ({enabled: !s.enabled}));
  }

  openForceRequiresPaymentModal(dispatch, err) {
    dispatch({
      type: MODAL_STATE.OPEN,
      modalName: "SelectOptionModal",
      modalType: MODAL_TYPE.STANDARD,
      payload: {
        modalId: "showModalForceRequiresPayment",
        title: locales_es.warning,
        hideCloseButton: false,
        actions: [
          {
            title: locales_es.proceedAnyway,
            className: "btn btn-warning",
            onClick: () => this.send(true),
          },
          {
            title: locales_es.cancel,
            className: "btn btn-danger",
            closeOnClick: true,
            onClick: () => console.log('canceled'),
          }
        ],
        children: (
          <>
            <div dangerouslySetInnerHTML={{__html: this.helpers.getErrorMsg(err)}}/>
            <br/>
            <p>⚠️ Si desea continuar, se activará el cobro online, y se configurarán automáticamente los medios de pagos
              para que sólo se cobre por MercadoPago, y se deshabilitarán las otras opciones de cobro</p>
          </>
        ),
      }
    });
  }

  openMercadoPagoLinkModal(dispatch, err) {
    const onClickLinkMercadoPago = () => {
      this.api.getMercadoPagoAuthorizationLink(window.location.origin).then(res => {
        window.location.href = res.data.url;
        // window.open(res.data.url, '_blank');
      }).catch(err => {
        this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err));
      })
    };
    dispatch({
      type: MODAL_STATE.OPEN,
      modalName: "SelectOptionModal",
      modalType: MODAL_TYPE.STANDARD,
      payload: {
        modalId: "showMercadoPagoLinkModal",
        title: locales_es.warning,
        hideCloseButton: false,
        actions: [
          {
            title: locales_es.linkMercadoPagoAccount,
            className: "btn btn-brand",
            onClick: onClickLinkMercadoPago,
          },
          {
            title: locales_es.cancel,
            className: "btn btn-danger",
            closeOnClick: true,
            onClick: () => console.log('canceled'),
          }
        ],
        children: (
          <>
            <div dangerouslySetInnerHTML={{__html: this.helpers.getErrorMsg(err)}}/>
            <br/>
            <p>Para activar el cobro obligatorio de los turnos debe contar con una cuenta de Mercado Pago vinculada.
              Haga click para configurar la suya.</p>
          </>
        ),
      }
    });
  }


  // Unified send with add/edit/delete prices
  send(force = false) {
    const {mode, prices} = this.state;
    const data = {
      medic_id: this.props.medic.id,
      type_id: this.state.appointmentTypeId,
      clinic_id: this.state.clinicId,
      consulting_room_id: this.state.consulting_room_id,
      day: this.state.day,
      start: this.state.start,
      end: this.state.end,
      duration: this.state.duration,
      comment: this.state.comment,
      footer_email_text: this.state.footer_email_text,
      enabled: Number(this.state.enabled),
      requires_payment: Number(this.state.requiresPayment),
      time_zone: this.state.timezone.value,
      start_date: this.state.startDate
        ? this.dateTimeService.getDateStartOfDay(this.state.startDate, false).toISOString()
        : undefined,
      end_date: this.state.endDate
        ? this.dateTimeService.getDateEndOfDay(this.state.endDate, false).toISOString()
        : undefined,
      limit_time_post_appointment: this.state.limitTimePostAppointment,
      limit_time_cancel_appointment: this.state.limitTimeCancelAppointment
    };

    this.setState({loading: true});
    const apiCall = (mode === 'add' || mode === 'clone')
      ? this.api.postTimetables(data, force)
      : this.api.putTimetable({id: this.props.timetableId, ...data}, force);

    apiCall.then(res => {
      const timetableId = res.data.id;
      const cb = () => {
        this.props.showMainModal(locales_es.successModal.title, res.message);
        window.location.href = `${HREF_PAGE_MEDIC_EDIT_TIMETABLES}/${this.props.medic.id}`;
      };
      if (mode === 'add' || mode === 'clone') {
        // after create, post all prices
        Promise.all(prices.map(p => this.api.postTimetablePrice({timetable_id: timetableId, ...p})))
          .then(() => cb())
          .catch(err => this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err)));
      } else {
        // edit: delete handled onRemovePrice, update existing and post new
        const toUpdate = prices.filter(p => p.id && p.index != null);
        const toAdd = prices.filter(p => !p.id);
        Promise.all([
          ...toUpdate.map(p => this.api.putTimetablePrice(p.id, p)),
          ...toAdd.map(p => this.api.postTimetablePrice({timetable_id: timetableId, ...p}))
        ])
          .then(() => cb())
          .catch(err => this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err)));
      }
    })
      .catch(err => this.setState({loading: false},
        () => {
          if (err?.status === 409) {
            const {dispatch} = this.props.modalContext;
            this.openForceRequiresPaymentModal(dispatch, err);
            return;
          }
          this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err));
        }
      ));
  }

  onSavePriceModal(price) {
    const prices = [...this.state.prices];
    if (price.index != null) prices[price.index] = price; else prices.push(price);
    this.setState({prices, price: null});
  }

  onRemovePrice(price, index) {
    if (this.state.mode === 'edit' && price.id) {
      this.setState({loading: true});
      this.api.deleteTimetablePrice(price.id)
        .then(() => {
          const prices = [...this.state.prices];
          prices.splice(index, 1);
          this.setState({prices, loading: false});
        })
        .catch(err => this.setState({loading: false},
          () => this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err))
        ));
    } else {
      const prices = [...this.state.prices];
      prices.splice(index, 1);
      this.setState({prices});
    }
  }

  onEditPrice(price, i) {
    this.setState({price: {...price, index: i}});
  }

  goBack() {
    window.history.back();
  }

  goToEditClinic() {
    window.location.href = `${HREF_PAGE_ADD_CLINIC}/${this.props.medic.id}/${this.state.clinicId}`;
  }

  render() {
    const {loading, mode, clinics, prices, price, currencies, amountTypes, editionDisabled} = this.state;
    const disabledBase = (mode === 'edit' || editionDisabled);

    const inputs = [];
    if (this.props.userType === USER_TYPE_SECRETARY) {
      inputs.push({
        label: locales_es.consultingRoom,
        placeholder: locales_es.consultingRoom,
        state: 'consulting_room_id',
        value: this.state.consulting_room_id,
        type: 'select',
        options: this.state.consultingRoomOptions,
        required: true,
        wrapperCustomClassName: 'form-group col-md-6 float-left pr-md-0',
      });
    }
    if (this.props.userType === USER_TYPE_MEDIC) {
      inputs.push({
        label: locales_es.consultingPlace,
        placeholder: locales_es.consultingPlace,
        state: 'clinicId',
        value: this.state.clinicId,
        type: 'select',
        options: this.state.clinics,
        required: true,
        wrapperCustomClassName: 'form-group',
        primaryAction: <a href="#" className="kt-link kt-link--brand" onClick={e => {
          e.preventDefault();
          this.goToEditClinic();
        }}>{locales_es.editThisAttentionPlace}</a>,
        secondaryAction: <a href={`${HREF_PAGE_ADD_CLINIC}/${this.props.medic.id}`}
                            className="btn btn-brand btn-sm btn-bold btn-upper">+ {locales_es.addClinic}</a>
      });
    }

    const inputsTwo = [
      {
        label: locales_es.day,
        state: 'day',
        value: this.state.day,
        type: 'select',
        options: DAYS_OF_THE_WEEK,
        required: true,
        disabled: disabledBase,
        wrapperCustomClassName: 'form-group col-md-6 float-left pl-md-0',
      },
      {
        label: `${locales_es.appointmentDuration} (${locales_es.inMinutes})`,
        state: 'duration',
        value: this.state.duration,
        type: 'number',
        step: 5,
        min: 1,
        max: 60,
        required: true,
        disabled: disabledBase,
        wrapperCustomClassName: 'form-group col-md-6 float-left pr-md-0',
      },
      {
        label: locales_es.observations,
        placeholder: locales_es.observationsPlaceholder,
        state: 'comment',
        value: this.state.comment,
        type: 'text',
        wrapperCustomClassName: 'form-group clear',
      },
      {
        label: locales_es.footerEmailText,
        placeholder: locales_es.footerEmailTextPlaceholder,
        state: 'footer_email_text',
        value: this.state.footer_email_text,
        type: 'textarea',
        wrapperCustomClassName: 'form-group clear'
      },
      {
        label: locales_es.appointmentType,
        state: 'appointmentTypeId',
        value: this.state.appointmentTypeId,
        type: 'select',
        options: this.state.appointmentTypes,
        required: true,
        wrapperCustomClassName: 'form-group col-md-6 float-left pl-md-0'
      },
      {
        label: locales_es.timezone,
        state: 'timezone',
        value: this.state.timezone,
        type: 'react-select',
        options: this.state.timezoneOptions,
        required: true,
        wrapperCustomClassName: 'form-group col-md-6 float-left pr-md-0'
      },
      {
        label: locales_es.startDate,
        placeholder: locales_es["DD/MM/YYYY"],
        state: 'startDate',
        value: this.state.startDate,
        type: 'date',
        nullable: true,
        wrapperCustomClassName: 'form-group col-md-6 float-left pl-md-0 clear',
        minDate: Date.now(),
        info: locales_es.startDateInfo
      },
      {
        label: locales_es.endDate,
        placeholder: locales_es["DD/MM/YYYY"],
        state: 'endDate',
        value: this.state.endDate,
        type: 'date',
        nullable: true,
        wrapperCustomClassName: 'form-group col-md-6 float-left pr-md-0',
        minDate: Date.now(),
        info: locales_es.endDateInfo
      },
      {
        label: `${locales_es.limitTimePostAppointmentDescription} (${locales_es.inHours})`,
        state: 'limitTimePostAppointment',
        value: this.state.limitTimePostAppointment,
        type: 'number',
        step: 1,
        min: 0,
        wrapperCustomClassName: 'form-group col-md-6 float-left pl-md-0 clear'
      },
      {
        label: `${locales_es.limitTimeCancelAppointmentDescription} (${locales_es.inHours})`,
        state: 'limitTimeCancelAppointment',
        value: this.state.limitTimeCancelAppointment,
        type: 'number',
        step: 1,
        min: 0,
        wrapperCustomClassName: 'form-group col-md-6 float-left pr-md-0'
      }
    ];

    const inputsThree = [
      {
        label: locales_es.from,
        state: 'start',
        value: this.state.start,
        type: 'time',
        required: true,
        step: 5,
        disabled: disabledBase,
        wrapperCustomClassName: 'form-group col-md-6 float-left pl-md-0 clear'
      },
      {
        label: locales_es.to,
        state: 'end',
        value: this.state.end,
        type: 'time',
        required: true,
        step: 5,
        disabled: disabledBase,
        wrapperCustomClassName: 'form-group col-md-6 float-left pr-md-0'
      }
    ];

    if (clinics === null) return <div className="m-5 p-5 text-center"><Spinner /></div>
    if (!clinics || clinics.length === 0) return <NoAttentionPlaces medicId={this.props.medic.id}/>;

    return (
      <>
        {loading && <Loading/>}
        <div className="kt-portlet__body">
          <div className="row">
            <div className="woopi-timetable-prices col-md-6 mb-5">{prices.length ?
              <PricesTable medic={this.props.medic} prices={prices} onRemove={this.onRemovePrice}
                           onEdit={this.onEditPrice}/> : (
                <div><h6 className="m-0 p-0">{locales_es.prices}</h6><br/><p>{locales_es.pricesEmptyText}</p></div>)}<p
              className="text-center text-md-left"><a href="#" className="kt-link kt-link--brand" onClick={e => {
              e.preventDefault();
              this.setState({price: true});
            }}><i className="flaticon2-plus"/> {locales_es.addPrice}</a></p></div>
            <Form inputs={inputs} handleChange={this.handleChange} wrapper={false} wrapperClassName="col-md-6"/>
          </div>
          <div className="row">
            <div className="col">
              <label className="kt-checkbox kt-checkbox--tick kt-checkbox--danger">
                <input type="checkbox"
                       onChange={this.toggleRequiresPayment}
                       checked={this.state.requiresPayment}/> {locales_es.requiresPaymentToBookAppointment}<span/>
              </label>
              <span
                className="form-text text-muted">El turno se confirma sólo si se abona dentro de los 15 minutos próximos</span>
            </div>
          </div>
        </div>
        <hr/>
        <Form styles="kt-form" inputs={inputsTwo} handleChange={this.handleChange}
              handleDateChange={this.handleDateChange} handleReactSelectChange={this.handleSelectChange}
              wrapper={true}/>
        <div className="row pl-4 pr-4">
          <div className="col"><h3>{locales_es.lapseTime}</h3><p>El horario de atención para que contenga a todos los
            turnos que quieres dar</p>{mode === 'edit' ? (<><h6>De momento no puede editarse la franja de atención. Si
            necesita ajustarla, deshabilite esta franja y cree una nueva.</h6><a
            href="https://nivian.app/medicloud/p/modificacion-de-horario" target="_blank">Ver issue</a></>) : (
            <h6>Ej.: Si quiero tener un último turno de 15 minutos a las 18hs., el horario de atención debe ser hasta
              las 18:15hs.</h6>)}</div>
          <div className="col"><Form styles="kt-form" inputs={inputsThree} handleChange={this.handleChange}
                                     handleDateChange={this.handleDateChange}
                                     handleReactSelectChange={this.handleSelectChange} wrapper={true}/></div>
        </div>
        <div className="row mt-5 pl-4 pr-4">
          <div className="col text-center"><label className="kt-checkbox"><input type="checkbox"
                                                                                 disabled={mode === 'edit' && editionDisabled}
                                                                                 onChange={this.toggleEnable}
                                                                                 checked={this.state.enabled}/> {locales_es.enabledTimetable}<span/></label>
          </div>
        </div>
        <div className="row m-4">
          <div className="col text-center">
            <button type="button" onClick={() => this.send()}
                    className={mode === 'edit' ? 'btn btn-warning btn-elevate btn-pill m-3' : 'btn btn-brand btn-elevate btn-pill mr-3'}>{mode === 'edit' ? locales_es.saveChanges : locales_es.save}</button>
            <button type="button" onClick={this.goBack}
                    className="btn btn-outline-brand btn-elevate btn-pill m-3">{locales_es.cancel}</button>
          </div>
        </div>
        {price && currencies && amountTypes && (
          <PriceModal price={price} currencies={currencies} currentAmountType={price.before_payment_type || PAYMENT_METHOD_AMOUNT_TYPE_PERCENT}
                      currentAmount={price.before_payment_amount || 100} amountTypes={amountTypes}
                      enableBeforePayment={this.state.enableBeforePayment} onSave={this.onSavePriceModal}
                      onCancel={() => this.setState({price: null})} showMainModal={this.props.showMainModal}/>)}
      </>
    );
  }
}

export default withModalContext(MedicTimetableForm);
